import NACell from '../Reusable/DataTable/NACell';
import moment from 'moment';
import Modal from '../Reusable/Modal';
import DataTable from '../Reusable/DataTable';
import APIS from '../../constant/EndPoint';
import { useState } from 'react';
import { tw } from '@careinfo/tailwind';
import Reply from './Reply';

const TicketList = (props: any) => {
  const [openReplyPopup, setOpenReplyPopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const defaultColumns: any = [
    {
      header: 'Subject',
      accessorKey: 'queue.name',
      cell: NACell,
    },
    {
      header: 'Description',
      accessorKey: 'description',
      cell: NACell,
    },
    {
      header: 'Reply',
      accessorKey: 'resolution',
      cell: ({ row, getValue }: any) => (
        <button
          onClick={() => {
            setSelectedRow(row);
            setOpenReplyPopup(!openReplyPopup);
          }}
          className={tw`foucus:outline-none`}
        >
          {getValue() ?? 'N/A'}
        </button>
      ),
    },
    {
      header: 'Priority',
      accessorKey: 'priority',
      cell: NACell,
    },
    {
      header: 'Created',
      accessorKey: 'created',
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()
                ? moment(getValue()).format('YY-MM-DD HH:mm:ss')
                : 'N/A'}
            </p>
          </>
        );
      },
    },

    {
      header: 'Status',
      accessorKey: 'status.name',
      cell: NACell,
    },
  ];

  return (
    <>
      <DataTable
        url={APIS.TICKET}
        queryKey={'ticket'}
        columns={defaultColumns}
        addNewPagePath={'/create'}
        tableName={'Ticket'}
        isUpload={false}
      />
      <Modal
        isOpen={openReplyPopup}
        setIsOpen={setOpenReplyPopup}
        title={'Reply'}
      >
        <Reply selectedRow={selectedRow} canInput={true} />
      </Modal>
    </>
  );
};

export default TicketList;
